import script from "./CustomModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomModal.vue?vue&type=script&lang=ts&setup=true"

import "./CustomModal.vue?vue&type=style&index=0&id=25a6b817&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a6b817"]])

export default __exports__